import { render, staticRenderFns } from "./PoiAddress.vue?vue&type=template&id=5536ba64&scoped=true"
import script from "./PoiAddress.vue?vue&type=script&lang=js"
export * from "./PoiAddress.vue?vue&type=script&lang=js"
import style0 from "./PoiAddress.vue?vue&type=style&index=0&id=5536ba64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536ba64",
  null
  
)

export default component.exports